import React from 'react';
import {
  Box,
  Button,
  HStack,
  Heading,
  Input,
  Stack,
  VStack,
  Text,
} from '@chakra-ui/react';
import { AiOutlineSend } from 'react-icons/ai';

const Footer = () => {
  return (
    <Box bgColor={'blackAlpha.900'} minH={'40'} p="16" color={'white'}>
      <Stack direction={['column', 'row']}>
        <VStack alignItems={'stretch'} w={'full'} px={'4'}>
          <Heading size="md" textTransform={'uppercase'} textAlign={'center'}>
            soulmate.com
          </Heading>
          <HStack borderBottom={'2px solid blue'} color={'white'}>
            <Input
              placeholder="Enter Email Here....."
              border={'none'}
              outline={'none'}   
              focusBorderColor="none"
            />
            <Button
              p={'0'}
              color={'white'}
              variant={'ghost'}
              borderRadius={'0 20px 20px 0'}
            >
              <AiOutlineSend size={20} />
            </Button>
          </HStack>
        </VStack>
        <VStack
          w={'full'}
          borderLeft={['none', '1px solid blue']}
          borderRight={['none', '1px solid blue']}
        >
          <Heading textTransform={'uppercase'} textAlign={'center'} color={'blue'}>
            Aayush Rai
          </Heading>
          <Text>We Make Our Future</Text>
        </VStack>
        <VStack w={'full'}>
          <Heading size={'md'} textTransform={'uppercase'}>
            Follow Me 
          </Heading>
          <Button variant={'link'} colorScheme={'blue'}>
            <a target={'black'} href="https://Youtube.com">
              Youtube
            </a>
          </Button>
          <Button variant={'link'} colorScheme={'blue'}>
            <a target={'black'} href="https://Youtube.com">
              Instagram
            </a>
          </Button>
          <Button variant={'link'} colorScheme={'blue'}>
            <a target={'black'} href="https://Youtube.com">
              Linkedin
            </a>
          </Button>
        </VStack>
      </Stack>
    </Box>
  );
};

export default Footer;
